import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c('EntityTableCard',{attrs:{"title":"Charging Plan Template Runs","identifier":"id","types":_vm.types,"readFunction":_vm.readFunction,"controls":_vm.controls,"disable-search":"","disable-bulk-control":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }